export const SPARTAN_PRODUCT_CUSTOMIZE_GRADE_DRAWER_INSTANCE_ID =
  'customize-grade';

export const SPARTAN_PRODUCT_CUSTOMIZE_GRADE_DRAWER_TITLE_ID = `${SPARTAN_PRODUCT_CUSTOMIZE_GRADE_DRAWER_INSTANCE_ID}-title`;

export const CUSTOMIZE_CONTROLS_REVEAL_OFFSET = '0%,0';

export const getSpartanCustomizeColorFallbackLabel = (index: number) =>
  `สีที่ ${index + 1}`;
